import { formatToTitleCase } from "@/utilities/functions/formatToTitleCase";
import React, { useCallback } from "react";

interface AgentInfoCardProps {
  title?: string;
  agentType?: string;
  name?: string;
  regNo?: string;
  estateAgency?: string;
  agencySize?: number;
  className?: string;
}

const AgentInfoCard: React.FC<AgentInfoCardProps> = ({
  title = "FraudDetect • Agent",
  agentType,
  name,
  regNo,
  estateAgency,
  agencySize,
  className = "",
}) => {
  const displayAgencySize = useCallback((size: number) => {
    if (size > 5500) {
      return `Large • More than 5,500 agents`;
    } else if (size >= 1000) {
      return `Medium • 1,000 - 5,500 agents`;
    } else {
      return `Small • Less than 200 agents`;
    }
  }, []);

  return (
    <div className={`bg-white rounded-lg p-6 shadow-sm ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

      <div className="space-y-4">
        {agentType && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Type of Agent
            </label>
            <p className="text-gray-600">{agentType}</p>
          </div>
        )}

        {name && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <p className="text-gray-600">{formatToTitleCase(name)}</p>
          </div>
        )}

        {regNo && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reg No
            </label>
            <p className="text-gray-600">{regNo}</p>
          </div>
        )}

        {estateAgency && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Estate Agency
            </label>
            <p className="text-gray-600">{formatToTitleCase(estateAgency)}</p>
          </div>
        )}

        {!!agencySize && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Agency Size
            </label>
            <p className="text-gray-600">{displayAgencySize(agencySize)}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AgentInfoCard;
